<template>
  <div  style="background-image: url('https://dceccpprdap6001.morningstar.com:8082/img/ms-backdrop-diag.4543ffea.png');background-size: cover;position: relative;display: flex;width: 100vw;height: 100vh;">
    <div
      style="
        background-color: white;
        border-radius: 10px;
        height: 58%;
        width: 35%;
        margin: auto;
        box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
      "
    >
     <section class="section">
        <div style="text-align: -webkit-center; padding-top: 1%;padding-bottom: 1%;">
          <img src="../assets/Mlogo_red.png" alt="" />
        </div>

        <p
          style="
            color: #005ba1;
            font-size: larger;
            font-weight: bold;
            text-align: -webkit-center;
          "
        >
        Conference Call Tracker
        </p>
        <br />
        <mds-form ref="form" :layout-size="size">
          <mds-alert
            v-if="showAlert"
            variation="error"
            v-bind:title="userDetails.message"
            tinted
            @mds-alert-dismissed="closeAlert"
          >
          </mds-alert>
          <mds-input
            v-bind="formData.UserName"
            class="inputClass"
            size="large"
          ></mds-input>
          <mds-input
            password
            v-bind="formData.Password"
            size="large"
          ></mds-input>
        </mds-form>
        <mds-button-container right-aligned style="padding-top: 2%;">
          <mds-button
            variation="primary"
            v-on:click="login"
            size="large"
            :loading="showLoader"
            :disabled="showLoader"
            >Submit</mds-button
          >
        </mds-button-container>
      </section>
    </div>
  </div>
</template>

<script>
import MdsForm from "@mds/form-vue3";
import MdsInput from "@mds/input-vue3";
import { MdsButton, MdsButtonContainer } from "@mds/button-vue3";
import MdsPageShell from "@mds/page-shell-vue3";
import MdsLoader from "@mds/loader-vue3";
import MdsAlert from "@mds/alert-vue3";
import { mapState, mapActions, mapMutations } from "vuex";
import { LOGIN_ACTION } from "@/store/storeconstants";
import router from "@/router";
import ModelLoader from "./ModelLoader.vue";

export default {
  name: "LoginComponent",
  components: {
    MdsForm,
    MdsButton,
    MdsButtonContainer,
    MdsInput,
    MdsPageShell,
    MdsLoader,
    MdsAlert,
    ModelLoader,
  },
  props: {
    size: {
      type: String,
      default: "medium",
    },
  },
  data() {
    return {
      formData: {
        UserName: {
          id: "UserName",
          label: "Email",
          required: true,
          error: false,
          errorText: ["Please enter a UserName"],
        },

        Password: {
          id: "Password",
          label: "Password",
          required: true,
          error: false,
          errorText: ["Please enter a Password"],
        },
      },
      showLoader: false,
      showAlert: false,
    };
  },
  methods: {
    ...mapActions("auth", {
      loginAction: LOGIN_ACTION,
    }),
    async login() {
      debugger;
      if (this.$el.querySelector("#UserName").value === "") {
        this.formData.UserName.error = true;
      } else {
        this.formData.UserName.error = false;
      }

      if (this.$el.querySelector("#Password").value === "") {
        this.formData.Password.error = true;
      } else {
        this.formData.Password.error = false;
      }

      if (
        this.formData.UserName.error === false &&
        this.formData.Password.error === false
      ) {
        this.showLoader = true;
        await this.loginAction({
          Email: this.$el.querySelector("#UserName").value,
          Password: this.$el.querySelector("#Password").value,
        }).catch((err) => {
          this.error = err;
        });
        this.showLoader = false;
        if (this.userDetails.success) {
          router.push({ path: "conferenceDetails" });
        } else {
          this.showAlert = true;
        }
      }
    },
    closeAlert() {
      this.showAlert = false;
    },
  },
  computed: {
    ...mapState("auth", {
      userDetails: (state) => state.userDetails,
    }),
  },
};
</script>

<style scoped>
/* @import "@mds/constants-vue3"; */
/* .sample-section-spacing-class {
  margin: $mds-space-2-x;
} */
.inputClass {
  width: 100%;
}

section {
  max-width: 100%;
  margin: 3%;
  padding: 5%
}
.bg{
    background-image: url('https://i.imgur.com/vHHl8Xk.jpg');
}
.ImageCenter {
  justify-content: center;
}
</style>
